import { render } from "./CoolButton.vue?vue&type=template&id=cb1bfb94&scoped=true"
const script = {}

import "./CoolButton.vue?vue&type=style&index=0&id=cb1bfb94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb1bfb94"]])

export default __exports__